import { Add, Remove } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';
import { useConfig } from '@hooks';

type InputNumberProps = {
  value: number
  minValue?: number,
  maxValue?: number,
  onMinus: () => void,
  onPlus: () => void
};

const InputNumber: React.FC<InputNumberProps> = ({ value, minValue, maxValue, onMinus, onPlus }) => {
  const { mode: clientMode } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";
  const borderColorClass = mode === "vacanceole" ? "tw-border-v_blue-dark" : "tw-border-primary_corseole-500";

  return <div className="tw-flex tw-items-center tw-gap-2">
    <button type="button" disabled={value === minValue} className={`tw-outline-none focus:tw-outline-none tw-flex tw-items-center tw-justify-center disabled:tw-text-gray-200 disabled:tw-border-gray-200 tw-border ${borderColorClass} tw-rounded-full tw-font-bold tw-w-10 tw-h-10 tw-transition-colors tw-duration-200 tw-ease-in-out`} onClick={onMinus}>
      <Remove fontSize="small" />
    </button>
    <input type="text" value={value} className="tw-w-8 tw-h-10 tw-text-center tw-outline-none tw-font-semibold tw-font-montserrat" readOnly></input>
    <button type="button" disabled={value === maxValue} className={`tw-outline-none focus:tw-outline-none tw-flex tw-items-center tw-justify-center disabled:tw-text-gray-200 disabled:tw-border-gray-200 tw-border ${borderColorClass} tw-rounded-full tw-font-bold tw-w-10 tw-h-10 tw-transition-colors tw-duration-200 tw-ease-in-out`} onClick={onPlus}>
      <Add fontSize="small" />
    </button>
  </div>;
};

InputNumber.propTypes = {
  value: PropTypes.number.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onMinus: PropTypes.func.isRequired,
  onPlus: PropTypes.func.isRequired
};

export default InputNumber;
